import { render } from "./DropzoneVue.vue?vue&type=template&id=5210f935&scoped=true"
import script from "./DropzoneVue.vue?vue&type=script&lang=js"
export * from "./DropzoneVue.vue?vue&type=script&lang=js"

import "./DropzoneVue.vue?vue&type=style&index=0&id=5210f935&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5210f935"]])

export default __exports__